const stats = [
  { value: '15,000+', label: 'Homeowners Helped' },
  { value: '$150M+', label: 'Kept In Pockets' },
  { value: '500+', label: 'Vetted Contractors' },
  { value: '4.9★', label: 'Average Rating' }
];

const logos = [
  'HomeAdvisor',
  'Angi',
  'Thumbtack',
  'BBB',
  'Google',
  'Yelp'
];

const SocialProofSection = () => {
  return (
    <section className="py-10 sm:py-12 md:py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6 sm:mb-8 lg:mb-12">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-2 sm:mb-3 lg:mb-4 px-4 leading-tight">
            Trusted by Homeowners Nationwide
          </h2>
          <p className="text-sm sm:text-base lg:text-lg text-gray-600 max-w-2xl mx-auto px-4 leading-relaxed">
            Thousands of smart homeowners are keeping more money by connecting directly with quality pros
          </p>
        </div>
        
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8 mb-8 sm:mb-12 lg:mb-16">
          {stats.map((stat, index) => (
            <div key={index} className="text-center p-3 sm:p-4 lg:p-6">
              <div className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-[#2B5BA6] mb-1 sm:mb-2 leading-tight">
                {stat.value}
              </div>
              <div className="text-xs sm:text-sm lg:text-base text-gray-600 leading-tight">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4 lg:gap-8 items-center">
          {logos.slice(0, 5).map((logo, index) => (
            <div
              key={index}
              className="flex items-center justify-center p-3 sm:p-4 lg:p-6 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow min-h-[70px] sm:min-h-[80px] lg:min-h-[100px]"
            >
              <span className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-gray-400">
                {logo}
              </span>
            </div>
          ))}
        </div>

        {/* Centered Yelp on desktop */}
        <div className="hidden lg:flex justify-center mt-8">
          <div className="flex items-center justify-center p-6 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow min-h-[100px] w-[calc(20%-2rem)]">
            <span className="text-3xl font-bold text-gray-400">
              {logos[5]}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProofSection;
